export default __webpack_public_path__ + "static/media/optionIconBlue.8bcf1b36.svg";